import Text, {
  TEXT_COLOR,
  TEXT_KIND,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_DISPLAY,
} from '@/bit/components/components.text';
import FormTemplate, { THEMES } from '@/components/formTemplate/index';
import { PERSONAL_DATA } from '@/constants/personalData';
import { calculateAddress } from '@/utils/address';

function PersonalDataView({
  formData,
  edit = null,
  step = null,
  withHorizontalSeparator = false,
  addressType,
}) {
  const address = calculateAddress(formData, addressType, true);
  const name = formData[PERSONAL_DATA.NAME.ID];
  const surname1 = formData[PERSONAL_DATA.LAST_NAME.ID];
  const surname2 = formData[PERSONAL_DATA.SECOND_SURNAME.ID];
  const docNumber = formData[PERSONAL_DATA.DOC_NUMBER.ID];
  const email = formData[PERSONAL_DATA.EMAIL.ID];
  const contactPhone = formData[PERSONAL_DATA.CONTACT_PHONE.ID];

  return (
    <div className="personal-data-view-container">
      <FormTemplate
        titleText={PERSONAL_DATA.TITLE}
        step={step}
        theme={THEMES.LONG}
        action={
          edit
            ? {
                onClick: edit,
                label: 'Editar',
              }
            : null
        }
        withHorizontalSeparator={withHorizontalSeparator}
      >
        <div className="personal-data-view-container">
          {name && (
            <div>
              <Text
                text="Nombre y DNI/NIE:&nbsp;"
                color={TEXT_COLOR.GREY6}
                kind={TEXT_KIND.SPAN}
                size={TEXT_SIZE.CAPTION2}
                display={TEXT_DISPLAY.INLINE}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
              />
              <Text
                text={`${name} ${surname1} ${surname2}${
                  docNumber ? `, ${docNumber}` : ''
                }`}
                color={TEXT_COLOR.GREY5}
                kind={TEXT_KIND.SPAN}
                size={TEXT_SIZE.CAPTION2}
                display={TEXT_DISPLAY.INLINE}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
              />
            </div>
          )}
          {email && contactPhone && (
            <div>
              <Text
                text="Datos de contacto:&nbsp;"
                color={TEXT_COLOR.GREY6}
                kind={TEXT_KIND.SPAN}
                size={TEXT_SIZE.CAPTION2}
                display={TEXT_DISPLAY.INLINE}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
              />
              <Text
                text={`${email}, ${contactPhone}`}
                color={TEXT_COLOR.GREY5}
                kind={TEXT_KIND.SPAN}
                size={TEXT_SIZE.CAPTION2}
                display={TEXT_DISPLAY.INLINE}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
              />
            </div>
          )}
          {address && (
            <div>
              <Text
                text={`${addressType.TITLE}:&nbsp;`}
                color={TEXT_COLOR.GREY6}
                kind={TEXT_KIND.SPAN}
                size={TEXT_SIZE.CAPTION2}
                display={TEXT_DISPLAY.INLINE}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
              />
              <Text
                text={address}
                color={TEXT_COLOR.GREY5}
                kind={TEXT_KIND.SPAN}
                size={TEXT_SIZE.CAPTION2}
                display={TEXT_DISPLAY.INLINE}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
              />
            </div>
          )}
        </div>
      </FormTemplate>
      <style jsx>
        {`
          .personal-data-view-container {
            margin-bottom: 12px;
          }
          :global(.checkbox-container) {
            margin-top: 8px;
          }
          :global(.address-container-wrapper) {
            padding-top: 12px;
          }
          .personal-data-view-container > * {
            margin-bottom: 8px;
          }
          .personal-data-view-container > *:last-child {
            margin-bottom: 0px;
          }
        `}
      </style>
    </div>
  );
}

export default PersonalDataView;
